import { useCallback, useState } from "react";

import usePaginatedResource from "hooks/usePaginatedResource";
import { listContent } from "api/endpoints/content";

/**
 * Batch 2.4 — useContentList. The paginated, filtered content list for one
 * content type, built on the shared `usePaginatedResource` (offset pagination,
 * centralized page sizes). Filter changes reset back to the first page.
 */
export default function useContentList({ websiteId, contentTypeId }) {
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");

  const fetchList = useCallback(
    (pageParams) => {
      if (!websiteId || !contentTypeId) return { items: [], total: 0 };
      const params = {
        ...pageParams,
        content_type_id: contentTypeId,
        sort_by: "updated_at",
        sort_desc: true,
      };
      if (status) params.status = status;
      if (search.trim()) params.search = search.trim();
      return listContent(websiteId, params);
    },
    [websiteId, contentTypeId, status, search]
  );

  const resource = usePaginatedResource(fetchList);
  const { setPage } = resource;

  const changeStatus = (value) => {
    setPage(0);
    setStatus(value);
  };

  const changeSearch = (value) => {
    setPage(0);
    setSearch(value);
  };

  return {
    items: resource.rows,
    total: resource.total,
    loading: resource.loading,
    page: resource.page,
    pageSize: resource.pageSize,
    setPage: resource.setPage,
    setPageSize: resource.setPageSize,
    refresh: resource.refresh,
    status,
    setStatus: changeStatus,
    search,
    setSearch: changeSearch,
  };
}
